// --------------------------------------------------------------------------
// enableTicketDetails.js
// --------------------------------------------------------------------------
// Enable ticket detail fields when users has selected a date
// --------------------------------------------------------------------------

RN.enableTicketDetails = function() {

  'use strict';

  var submitButton = byElement('enable-plan-submit');
  var ticketDetails = byElement('ticket-details');
  var ticketTypes = byBehaviour('enable-plan-submit');

  function init() {

    ticketTypes.find('input').each(function(){
      this.value = 0;
    });

    byBehaviour('enable-ticket-details').on('change', enableTickets);
    ticketTypes.on('change', handleTicketTypes);

  }

  function enableTickets() {
    ticketDetails.removeClass('plan-tickets-ticket-types--is-disabled');
    $('html, body').stop().animate({
        scrollTop: ticketDetails.offset().top + 'px'
      }, 500);
  }

  function handleTicketTypes() {
    var inputs = $(this).find('input');

    inputs.each(function(){
        if(this.value > 0){
            submitButton.prop('disabled', false);
            return false;
        }
        else{
            submitButton.prop('disabled', true);
        }
    });

  }


  return {
    init: init
  };

}();